import {API_PATH, HTTP_OK} from '@app/common/constants';
import {NetworkService, ToasterService} from '@app/services';
import {ToastType} from '@app/services/toaster';
import {takeLatest, put, call} from 'redux-saga/effects';
import {
  createPolicyUploadDataCreatorTypeName,
  policyUploadStateActions,
  fetchDivisionsCreatorTypeName,
  fetchAllRolesCreatorTypeName,
  fetchPolicyTypesCreatorTypeName,
} from './slice';

// Division Dropdown watcher
export function* fetchDivisionsDropdownWatcher() {
  yield takeLatest(fetchDivisionsCreatorTypeName, fetchDivisionsWorker);
}

// Division Dropdown worker
export function* fetchDivisionsWorker(): any {
  const url = `${API_PATH.moduleSpecificUtilities.policyUpload.dropdowns.divisions}`;
  
  try {
    const response = yield call(NetworkService.get, url, {}, {});
    if (response.status === HTTP_OK) {
      yield put(policyUploadStateActions.setDivisions(response?.data));
    } else {
      yield put(policyUploadStateActions.setDivisionError());
    }
  } catch (error) {
    yield put(policyUploadStateActions.setDivisionError());
  }
}

//Roles dropdown watcher
export function* fetchAllRolesDropdownWatcher() {
  yield takeLatest(fetchAllRolesCreatorTypeName, fetchAllRolesWorker);
}

// Roles Dropdown worker
export function* fetchAllRolesWorker(): any {
  const url = `${API_PATH.moduleSpecificUtilities.policyUpload.dropdowns.roles}`;
  
  try {
    const response = yield call(NetworkService.get, url, {}, {});
    const rolesList = response?.data && [...response?.data]
    if (response.status === HTTP_OK) {
      yield put(policyUploadStateActions.setRoles(rolesList));
    } else {
      yield put(policyUploadStateActions.setRolesError());
    }
  } catch (error) {
    yield put(policyUploadStateActions.setRolesError());
  }
}

/**
 * Policy Upload Data Watcher
 */
export function* createPolicyUploadDataWatcher() {
  yield takeLatest(
    createPolicyUploadDataCreatorTypeName,
    createPolicyUploadDataWatcherWorker,
  );
}

/**
 * Policy Upload Data Worker
 */
export function* createPolicyUploadDataWatcherWorker(action: any): any {
  let errorMessage = 'Something went wrong while posting policy upload data!';
  try {
    const url = `${API_PATH.moduleSpecificUtilities.policyUpload.postUploadPolicy}`;
    yield put(policyUploadStateActions.setIsPolicyUploading(true));
    let data = action.payload;
    yield put(policyUploadStateActions.setIsPolicyUploading(true));
    let responsedata = yield call(NetworkService.postUploadFile, url, data);
    yield put(policyUploadStateActions.setIsPolicyUploading(false));
    if (
      responsedata?.data?.message &&
      !responsedata?.data?.isCreated &&
      responsedata?.status === HTTP_OK
    ) {
      ToasterService.showToaster(
        `${responsedata?.data?.message}`,
        ToastType.ERROR,
      );
    } else if (
      responsedata?.data?.message &&
      responsedata?.status === HTTP_OK
    ) {
      ToasterService.showToaster(
        `${responsedata?.data?.message}`,
        ToastType.SUCCESS,
      );
      yield put(policyUploadStateActions.setIsPolicyUploading(false));
    } else {
      if(responsedata && responsedata.data && responsedata.data.error) {
        errorMessage = responsedata.data.error;
      }
      // Handle the error message from "details" array if available
      if (responsedata?.data?.details && Array.isArray(responsedata?.data.details) && responsedata?.data.details.length > 0) {
        errorMessage = responsedata?.data.details[0].message || errorMessage;
      } else if (responsedata?.data?.error) {
        errorMessage = responsedata?.data.error;
      }

      ToasterService.showToaster(
        errorMessage,
        ToastType.ERROR,
      );
    }
  } catch (error) {
    ToasterService.showToaster(
      errorMessage,
      ToastType.ERROR,
    );
  }
}

/**
 * Fetch Policy Types Watcher
 */
export function* fetchPolicyTypesWatcher() {
  yield takeLatest(fetchPolicyTypesCreatorTypeName, fetchPolicyTypesWorker);
}

/**
 * Fetch Policy Types Worker
 */
export function* fetchPolicyTypesWorker(): any {
  const url = `${API_PATH.moduleSpecificUtilities.policyUpload.dropdowns.policyTypes}`;
  
  try {
    const response = yield call(NetworkService.get, url, {}, {});
    
    if (response.status === HTTP_OK) {
      // Assuming `response.data` contains the list of policyTypes
      yield put(policyUploadStateActions.setPolicyTypes(response?.data));
    } else {
      ToasterService.showToaster('Failed to fetch policy types!', ToastType.ERROR);
    }
  } catch (error) {
    ToasterService.showToaster('Error while fetching policy types!', ToastType.ERROR);
  }
}